import { gql } from '@apollo/client';

export const removeCredGql = gql`
  mutation removeCredOnContract(
    $contractId: String!
    $credential: CredentialInput!
  ) {
    removeCredOnContract(contractId: $contractId, credential: $credential) {
      _id
      credentials {
        type
        provider
        value
        description
      }
    }
  }
`;
